var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _rect, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryBio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 37.748C6.50508 38.5082 7.54335 39.1526 8.19995 39.6779C8.81946 40.1735 9.46845 40.5439 10.1674 40.9196C11.303 41.53 12.8877 41.9768 14.1775 42.0055C15.3929 42.0325 16.171 41.6761 17.1556 40.9411C17.8034 40.4575 18.0385 39.8074 18.4994 39.1672C18.6626 38.9406 18.8494 38.5461 19.0907 38.4254",
    stroke: "#DFDFDF",
    strokeWidth: 8.34788,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2891 37.748C48.909 38.5082 47.8707 39.1526 47.2141 39.6779C46.5946 40.1735 45.9456 40.5439 45.2467 40.9196C44.111 41.53 42.5264 41.9768 41.2365 42.0055C40.0211 42.0325 39.2431 41.6761 38.2585 40.9411C37.6107 40.4575 37.3756 39.8074 36.9146 39.1672C36.7515 38.9406 36.5647 38.5461 36.3233 38.4254",
    stroke: "#DFDFDF",
    strokeWidth: 8.34788,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7979 35.6288C25.7215 37.1127 25.8545 40.3051 25.0936 42.4398C24.1388 45.1183 21.8658 46.2608 19.4901 47.4729C17.1418 48.6711 14.113 49.0806 11.5093 48.69C9.576 48.4 7.10472 48.1275 5.49124 46.9453",
    stroke: "white",
    strokeWidth: 8.34788,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6172 35.6288C29.6935 37.1127 29.5605 40.3051 30.3215 42.4398C31.2763 45.1183 33.5492 46.2608 35.9249 47.4729C38.2732 48.6711 41.3021 49.0806 43.9057 48.69C45.839 48.4 48.3103 48.1275 49.9238 46.9453",
    stroke: "white",
    strokeWidth: 8.34788,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3317 22.743C47.3317 33.0944 38.9401 45.3506 28.5887 45.3506C18.2372 45.3506 9.8457 33.0944 9.8457 22.743C9.8457 12.3915 18.2372 4 28.5887 4C38.9401 4 47.3317 12.3915 47.3317 22.743Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3382 9.71464C13.9532 13.0034 14.2004 16.8348 14.8721 18.3394C17.0484 21.3621 20.0712 20.2337 26.0764 18.0976C32.0815 15.9616 32.807 11.2058 31.1949 8.6264C29.5827 6.04699 23.8194 5.60366 18.3382 9.71464Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.29 34.4531C27.0658 35.3783 30.0667 35.3783 32.8424 34.4531",
    stroke: "#37204B",
    strokeWidth: 2.28348,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9014,
    cy: 25.1636,
    r: 7.23884,
    fill: "white",
    stroke: "#242B7F",
    strokeWidth: 2.04391
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.2754,
    cy: 25.1636,
    r: 7.23884,
    fill: "white",
    stroke: "#242B7F",
    strokeWidth: 2.04391
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.9707,
    y: 24.0942,
    width: 1.19228,
    height: 2.044,
    fill: "#242B7F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3385,
    cy: 25.2159,
    r: 3.47248,
    transform: "rotate(-9.12201 37.3385 25.2159)",
    fill: "#37204B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5063,
    cy: 22.8217,
    r: 1.63411,
    transform: "rotate(-9.12201 35.5063 22.8217)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9224,
    cy: 25.2159,
    r: 3.47248,
    transform: "rotate(-9.12201 19.9224 25.2159)",
    fill: "#37204B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0893,
    cy: 22.8217,
    r: 1.63411,
    transform: "rotate(-9.12201 18.0893 22.8217)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBio);
export default __webpack_public_path__ + "static/media/category_bio.26629d5f68046bfb377899159e642567.svg";
export { ForwardRef as ReactComponent };